import { app } from '../../../../../app';
import { Controller } from './directory-manage-connection-azure.controller';

app.component('companyDirectoryIntegrationManageConnectionAzure', {
    bindings: {
        tenantParameters: '<',
        companyId: '<',
        directoryId: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-connection-azure.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection-azure/directory-manage-connection-azure.component.js